/**
 * @generated SignedSource<<3bbb9949492c9f42e76c35772624e3c0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductSwitcherTaskInput = {
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation$variables = {
  input: ProductSwitcherTaskInput;
};
export type salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation$data = {
  readonly generateProductSwitcherTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation = {
  response: salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation$data;
  variables: salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateProductSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "3d29e9db44bc10316fd9d51f97954c3c",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelSwitchQueriesGenerateProductSwitcherTaskMutation(\n  $input: ProductSwitcherTaskInput!\n) {\n  generateProductSwitcherTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b68f4c9bc92d76e93e05fc4a5216da4";

export default node;
